import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const GenericEmptyState = {
  generics: [],
  selectedGeneric: null,
};

export const GenericKey = 'generics';

export const genericsSlice = createSlice({
  name: 'generics',
  initialState: getLocalStorage(LocalStorageTypes.GENERICS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.GENERICS))
    : GenericEmptyState,
  reducers: {
    setGenerics: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.GENERICS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedGeneric: (state, action) => {
      const result = { ...state, selectedGeneric: action.payload };
      persistLocalStorage(GenericKey, result);
      return result;
    },

    resetGenerics: () => {
      clearLocalStorage('generics');
      return GenericEmptyState;
    },
  },
});

export const { setGenerics, updateSelectedGeneric, resetGenerics } =
  genericsSlice.actions;
